// auth.guard.ts - blocks access if not authenticated
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthServerProvider } from 'src/app/core/auth/auth-jwt.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthServerProvider, private router: Router) {}
  canActivate(): boolean | UrlTree {
    return this.auth.isAuthenticated() ? true : this.router.parseUrl('/login');
  }
}
